import { useEffect, useState } from 'react'

import { useRecommendedForYouQuery } from '../../../generated/frontend'
import { Consent, hasCookieConsent } from '../../utils/hasCookieConsent'
import { NonPersonalisedRecommededForYou } from './components/NonPersonalisedRecommededForYou/NonPersonalisedRecommededForYou'
import { RecommendedForYouContainer } from './components/RecommendedForYouContainer/RecommendedForYouContainer'
import type { Layout } from './layouts'
import type { RecommendationsType } from './models'

type RecommendedForYouProps = {
  whichId: string
  layout: Layout
}

type PersonalisedRecommededForYouProps = RecommendedForYouProps

export const PersonalisedRecommededForYou = ({
  whichId,
  layout,
}: PersonalisedRecommededForYouProps) => {
  const [recommendations, setRecommendations] = useState<RecommendationsType | undefined>()
  const { data, loading } = useRecommendedForYouQuery()

  useEffect(() => {
    if (loading) {
      return
    }

    const recommendations = data?.homePage?.recommendations
    setRecommendations(recommendations)
  }, [loading, data])

  if (recommendations?.models && recommendations.models.length > 0) {
    return (
      <RecommendedForYouContainer
        recommendations={recommendations}
        whichId={whichId}
        layout={layout}
      />
    )
  }

  return null
}

export const RecommendedForYou = (props: RecommendedForYouProps) => {
  const [showPersonalised, setShowPersonalised] = useState<boolean | null>(null)

  useEffect(() => {
    const hasFunctionalConsent = hasCookieConsent(Consent.FunctionalAndPerformance)

    setShowPersonalised(hasFunctionalConsent)
  }, [])

  if (showPersonalised === null) {
    return null
  }

  if (showPersonalised) {
    return <PersonalisedRecommededForYou {...props} />
  }

  return <NonPersonalisedRecommededForYou {...props} />
}
